export default class Anchor {
  constructor() {
    this.$links = document.querySelectorAll('.js-anchor');

    this.$links.forEach($link => {
      $link.addEventListener('click', e => {
        e.preventDefault();

        const $el = document.querySelector($link.getAttribute('href'));
        const $header = document.querySelector('.js-header');

        history.replaceState(null, null, $link.getAttribute('href'));

        if ($el) {
          const headerHeight = $header.offsetHeight;
          const elTop = $el.getBoundingClientRect().top;
          const scrollPos = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

          window.scrollTo({
            top: elTop + scrollPos - headerHeight,
            behavior: 'smooth'
          });
        }
      });
    });
  }
}
